import { toast } from "react-toastify";
import axios from "axios";
import { getTabDetails, profileTypeEndPoint } from "../ProfileHeader/profile-enum";
import { redirectingProfileEnum, redirectionTypePayload } from "@core/global/global-country-dictionary";
import { globalCountryDetailsDictionary } from "@core/global/global-country-details";
import { BRAND } from "@core/brand/brand-config";
import Dashboard from "@assets/images/icons/icon.svg";
import styles from "./ProfileTable.module.scss";
import ReactTooltip from "react-tooltip";
import { captureException } from "@sentry/react";

const TabelRedirectionColumn = ({ fromDashboard, tabType, companyName = "", dataSource, companyId, subCategory, isRedirect = true, isRedirectCallingSlug = false, redirectEvent = false, companyRedirectionEvent = () => null, globalPlan, hsDescription, isSalesForce }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const navigateUserToCompanyProfile = () => {
    if (isRedirectCallingSlug) {
      const params = {
        companyId,
      };
      if (fromDashboard) {
        params.from = "dashboard";
      }
      axios
        .get(profileTypeEndPoint.getCompanySlug, {
          params,
        })
        .then((res) => {
          const {
            status,
            data: { companySlug, aliasCompanyId },
          } = res.data;
          const successData = status && status.toUpperCase() === "success".toUpperCase() && !!companySlug && companySlug !== "" ? true : false;
          if (successData) {
            let url = "";
            if (companySlug && aliasCompanyId) {
              url = "/companies/" + companySlug + "/" + aliasCompanyId;
            }

            if (dataSource && Array.isArray(dataSource) && dataSource[0] && dataSource[0].key && dataSource[0].key.split(" ") && dataSource[0].key.split(" ")[0] && dataSource[0].key.split(" ")[1]) {
              const countryAndDirection = dataSource[0].key.split(" ");
              url = url + "?country=" + countryAndDirection[0].toUpperCase() + "&type=" + countryAndDirection[countryAndDirection.length - 1].slice(0, countryAndDirection[countryAndDirection.length - 1].length - 1).toLowerCase();
            }
            if (dataSource?.length === 0 && getTabDetails[subCategory]) {
              url = url + "?tab=" + getTabDetails[subCategory];
            } else if (getTabDetails[subCategory]) {
              url = url + "&tab=" + getTabDetails[subCategory];
            }
            window.open(url, "_blank");
            if (redirectEvent) {
              companyRedirectionEvent();
            }
          } else {
            toast.error("No company profile found in our system !!!");
          }
        })
        .catch((error) => {
          captureException(error);
          toast.error("Something went wrong. Please try again later !!!");
        });
    }
  };

  const navigateUserToHsCodeProfile = () => {
    const country = urlParams.get("country");
    const type = urlParams.get("type");
    let url = "";
    url = "/" + redirectingProfileEnum.sixDigitHsCode.payloadType + "/" + companyName;

    if (dataSource && Array.isArray(dataSource) && dataSource[0] && dataSource[0].key && dataSource[0].key.split(" ") && dataSource[0].key.split(" ")[0] && dataSource[0].key.split(" ")[1]) {
      const countryAndDirection = dataSource[0].key.split(" ");
      url = url + "?country=" + `${countryAndDirection.length > 2 ? dataSource[0].countryCode : countryAndDirection[0]}` + "&type=" + countryAndDirection[countryAndDirection.length - 1].slice(0, countryAndDirection[countryAndDirection.length - 1].length - 1).toLowerCase();
    } else if (globalPlan) {
      // A global-plan row carries no per-dataset source, so fall back to the
      // global dataset rather than multicountry, which such an account may not hold.
      const { country_small: globalCountry, countryType: globalType } = globalCountryDetailsDictionary.global_plan;
      url = url + `?country=${encodeURIComponent(globalCountry)}&type=${globalType}`;
    } else {
      url = url + `?country=${country ? country : "multicountry"}&type=${type ? type : "import"}`;
    }
    window.open(url, "_blank");
    if (redirectEvent) {
      companyRedirectionEvent("_hs_code");
    }
  };

  // Intel's global plan renders HS codes as plain text: a global-plan account has
  // no country/direction to open an HS code profile against. Source Atlas is
  // global-only, so that rule would strip every HS code row of its description
  // and its link to the HS code profile - which does serve the global dataset.
  const hideHsCodeProfileLink = tabType && tabType === redirectionTypePayload.sixDigitHsCode && globalPlan && BRAND.key !== "source_atlas";

  return companyName && companyName.length && isRedirect ? (
    hideHsCodeProfileLink ? (
      <>{companyName}</>
    ) : (
      <div
        className={`text-capitalize ${fromDashboard ? "trademo-link-dashboard" : "trademo-link"} ${isSalesForce ? "!tw-cursor-not-allowed" : ""}`}
        onClick={
          isSalesForce
            ? () => {
                return;
              }
            : tabType && tabType === redirectionTypePayload.sixDigitHsCode
              ? () => navigateUserToHsCodeProfile()
              : () => navigateUserToCompanyProfile()
        }>
        {hsDescription && hsDescription.length ? (
          <span className={styles.hscode_description_container} data-tip={hsDescription} data-for="hscode_description">
            <span>{companyName}</span>: <span className={styles.hscode_description}>{hsDescription}</span>
          </span>
        ) : (
          <>{companyName}</>
        )}
        <ReactTooltip id="hscode_description" className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" zIndex={100} place="right" effect="float" />
        {fromDashboard ? <img src={Dashboard} /> : <></>}
      </div>
    )
  ) : (
    <div className="text-capitalize">{companyName}</div>
  );
};
export default TabelRedirectionColumn;
